<div *ngIf="!showOnlyRouterOutLetPage" class="col-md-12 row clear-all flow-content">
  <app-header *ngIf="enableHeader"></app-header>
  <div class="container m-auto">
    <div class="top-container">
      <div *ngIf="enableBreadCrumbFeature" class="breadcrumb-container">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <div class="content-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <app-footer *ngIf="enableFooter"></app-footer>
</div>
<div *ngIf="showOnlyRouterOutLetPage">
  <router-outlet></router-outlet>
</div>